import styled from '@emotion/styled'

const FALLBACK_BACKGROUND =
	'conic-gradient(from 0deg at 50% 50%, rgb(0, 255, 255), rgb(255, 0, 255), rgb(255, 255, 0), rgb(0, 255, 255))'

const ColorCircle = styled.label<{ fill?: string }>`
	position: relative;
	width: 40px;
	height: 40px;
	border-radius: ${({ theme }) => theme.borderRadiuses.round};
	background: ${({ fill }) => fill || FALLBACK_BACKGROUND};
	margin-right: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${({ theme }) => theme.colorPalette.grayscale[0]};
	cursor: pointer;

	&:last-of-type {
		margin-right: 0;
	}
`

export default ColorCircle
